import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3842",
				"data-name": "Rectangle 3842",
				width: 16,
				height: 16,
				transform: "translate(0 0)"
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_7233",
			"data-name": "Group 7233",
			transform: "translate(0 -0.001)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_7232",
				"data-name": "Group 7232",
				transform: "translate(0 0.001)",
				clipPath: "url(#clip-path)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_19277",
					"data-name": "Path 19277",
					d: "M0,12.668V16H3.333l9.83-9.83L9.83,2.838ZM15.74,3.593a.885.885,0,0,0,0-1.253L13.661.26a.885.885,0,0,0-1.253,0L10.781,1.887,14.114,5.22,15.74,3.593",
					transform: "translate(0 -0.001)"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
